import React from 'react';
import PropTypes from 'prop-types';

import { Select } from 'spicecomponents';

const BreakGroup = (props) => {
  const {
    cdf,
    controlList,

    value,
    onChange,
  } = props;

  const getSurvey = () => {
    const survey = cdf.Survey;
    if (!survey || survey.length > 1) {
      return 'AllSurveys';
    }
    return survey[0];
  };
  const options = (() => {
    const availableBreaks = controlList.Options[getSurvey()];
    return availableBreaks.map((g) => (
      {
        value: Object.keys(g)[0],
        text: Object.values(g)[0].BreakGroupLabel,
      }
    ));
  })();
  return (
    <div>
      <label htmlFor="breakGroup">Select Customer Group</label>
      <Select name="breakGroup" placeholder="None" options={options} onChange={onChange} value={value || null} />
    </div>
  );
};

BreakGroup.propTypes = {
  cdf: PropTypes.object,
  onChange: PropTypes.func,
  value: PropTypes.string,
  controlList: PropTypes.object,
};

export default BreakGroup;



// WEBPACK FOOTER //
// ./app/components/FormControls/BreakGroup_BreakAnswer/BreakGroup.js